// extracted by mini-css-extract-plugin
export default {"Paper":"SubMenu_Paper__kB8vy"};